import $ from "jquery";

export class PcxAdapter {
    constructor() {
        this.processingMessage = "Payment Process Underway – Waiting for payment confirmation from Pay Connexion";
    }
    init(data, driver) {
        // the pcx adapter never resolves, instead it calls directly to the driver when done.
        // this is because the submission of the project is done by the RTPC processing and we dont want to
        // submit the project again.
        this.promise = new Promise((_resolve, _reject) => {
            this.resolve = _resolve; // capture internal _resolve into resolve
            this.reject = _reject; // same, but for _reject/reject
        });
        if (data) {
            this._frameParams = data.FormValues;
            this._postUrl = data.FormPostUrl;
        }
        this._$form = null;
        this._driver = driver;
    }

    checkout() {
        this.$formContainer = $("#PaymentFormContainer");
        if (this.$formContainer.length === 0) {
            this.$formContainer = $("<div><div>").attr({ id: "PaymentFormContainer" });
            $("body").append(this.$formContainer);
        }
        this.$formContainer.empty();

        this._$form = $("<form></form>").attr({ action: this._postUrl, method: "post", target: "_blank" });
        this._frameParams.forEach(function (kvp) {
            this._$form.append($("<input/>").attr({ name: kvp.Key, value: kvp.Value, type: "hidden" }));
        }, this);

        this.$formContainer.append(this._$form);
        this._$form.submit();
        this._driver.$app.unBlockUi();
        this.delayedSubmit();
        return this.promise;
    }
    delayedSubmit(driver) {
        if (driver) {
            this._driver = driver;
        }
        setTimeout(this._checkChargeStatus.bind(this), 2000);
    }
    cancelDelayedSubmit() {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
    }
    async _checkChargeStatus() {
        //ignore if chargeId is null since the check will fail anyway
        if (!this._driver.chargeId) {
            return;
        }
        const result = await this._driver.PayConnexionCheckChargeStatus();

        if (result.Data.RtpcMessageProcessed) {
            this._driver.$app.setUnsavedChanges(false);
            this._driver.showDialogAndNavigateToNext(result.Data.ReceiptInfo, result.Data.NavigateUrl);
        } else {
            // we have an initial wait of 2 secs, and then we check the status every 1 sec.
            // The initial wait is longer since it takes time to fill out the pcx page.
            // No need to make this poll too fast. It usually doesn't make a huge difference,
            // but in cases with lots of traffic in programs using these adapters the number of
            // requests can jump up real fast
            this.timeout = setTimeout(this._checkChargeStatus.bind(this), 1000);
        }
    }
}
